import { axiosWithAuth } from "@/lib/AxiosClient";

export class Project {
  constructor(id: string, name: string, siteId: string, tenantId: string, priorityCodeId: string, stageCodeId: string, staffDays: number, cost: number, startDate: string | null, endDate: string | null) {
    this.id = id
    this.name = name
    this.siteId = siteId
    this.tenantId = tenantId
    this.priorityCodeId = priorityCodeId
    this.stageCodeId = stageCodeId
    this.staffDays = staffDays
    this.cost = cost
    this.startDate = startDate
    this.endDate = endDate
  }

  id: string
  name: string
  siteId: string
  tenantId: string
  priorityCodeId: string
  stageCodeId: string
  staffDays: number
  cost: number
  startDate: string | null
  endDate: string | null
}

export class ProjectService {
  private static readonly BASE_PATH = "/api/projects"
  private static instance = axiosWithAuth;

  static async getById(projectId: string): Promise<Project> {
    const response = await this.instance.get<Project>(`${this.BASE_PATH}/${projectId}`);
    return response.data;

  }

  static async create(project: Project): Promise<Project> {
    const response = await this.instance.post<Project>(this.BASE_PATH, project);
    return response.data;
  }  

  static async update(projectId: string, project: Project): Promise<void> {
    await this.instance.put<void>(`${this.BASE_PATH}/${projectId}`, project);
  }

  static async getBySiteId(siteId: string): Promise<Project[]> {
    const response = await this.instance.get<Project[]>(`${this.BASE_PATH}/site/${siteId}`);
    return response.data
  }

  static async delete(projectId: string): Promise<void> {
    await this.instance.delete<void>(`${this.BASE_PATH}/${projectId}`);
  }
}